
























































































































import { Vue } from "vue-property-decorator";
import { WarehouseLocationServiceProxy } from '@/service-proxies/app-v2/warehouse.service-proxies'
import { MaterialCollectionRecordServiceProxy, PlanMaterialServiceProxy } from '@/service-proxies/app-v2/coproduction.service-proxies';
const pmsp = new PlanMaterialServiceProxy()
const whlsp = new WarehouseLocationServiceProxy()
const mcrsp = new MaterialCollectionRecordServiceProxy()

const columns = [
  {
    title: 'page_business_material_code',
    dataIndex: 'materialCode',
    scopedSlots: { customRender: 'materialCode' },
    ellipsis: true,
    width: 150
  },
  {
    title: 'page_business_material_name',
    dataIndex: 'materialName',
    scopedSlots: { customRender: 'materialName' },
    ellipsis: true,
    width: 150
  },
  {
    title: 'page_business_specifications',
    dataIndex: 'standardModel',
    scopedSlots: { customRender: 'standardModel' },
    ellipsis: true,
    width: 150
  },
  {
    title: 'page_workstation_maintain_unit',
    dataIndex: 'unit',
    scopedSlots: { customRender: 'unit' },
    ellipsis: true,
    width: 150
  },
  {
    title: 'page_plan_demand_quantity',
    dataIndex: 'requireNum',
    scopedSlots: { customRender: 'requireNum' },
    ellipsis: true,
    width: 150
  },
  {
    title: 'page_material_ware_out_stockOutNum',
    dataIndex: 'stockOutNum',
    scopedSlots: { customRender: 'stockOutNum' },
    ellipsis: true,
    width: 150
  },
  {
    title: 'page_plan_collection_quantity_received',
    dataIndex: 'acceptedNum',
    scopedSlots: { customRender: 'acceptedNum' },
    ellipsis: true,
    width: 150
  },
  {
    title: 'page_plan_collection_refund_personnel',
    dataIndex: 'collectionPerson',
    scopedSlots: { customRender: 'collectionPerson' },
    ellipsis: true,
    width: 150
  },
  {
    title: 'page_material_warehousing_area',
    dataIndex: 'area',
    scopedSlots: { customRender: 'area' },
    ellipsis: true,
    width: 150
  },
  {
    title: 'page_material_warehousing_location',
    dataIndex: 'location',
    ellipsis: true,
    scopedSlots: { customRender: 'location' },
    width: 150
  },
  {
    title: 'page_plan_collection_quantity_returned_this_time',
    dataIndex: 'number',
    ellipsis: true,
    scopedSlots: { customRender: 'number' },
    width: 150
  }
]
export default Vue.extend({
  data(){
    return {
      form: this.$form.createForm(this),
      dataSource: [],
      cacheData: [],
      locationList: [], // 库位列表
      loading: false
    }
  },
  props:{
    visible:{
      type: Boolean,
      default: false
    },
    allAreaList:{
      type: Array,
      default: () => ([])
    },
    employeesList:{
      type: Array,
      default: () => ([])
    },
    plan:{
      type: Object,
      default: () => ({})
    }
  },
  watch:{
    visible:{
      handler(){
        if(this.visible){
          this.dataSource = []
          console.log(this.plan)
          pmsp.materialList("",this.plan.id).then(res =>{
            this.dataSource = this.review(res)
            this.cacheData = this.dataSource
          })
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    columns() {
      return columns.map((item) => {
        return {
          ...item,
          title: this.$t(item.title)
        }
      })
    },
  },
  methods:{
    review(res){
      const data = []
      if(res && res.length > 0){
        res.forEach((item,index) => {
          const value = {
            key: index,
            materialCode: item.materialCode,
            materialId: item.materialId,
            materialName: item.materialName,
            standardModel: item.standardModel,
            unit: item.unit,
            requireNum: item.requireNum,
            stockOutNum: item.stockOutNum,
            acceptedNum: item.acceptedNum,
            numNotAccepted: item.numNotAccepted,
            area: "",
            collectionPerson: "",
            location: "",
            number: 0,
            planMaterialId: item.id
          }
          data.push(value)
        });
      }
      return data
    },
    handleChange(value, record, column) {
      const newData = [...this.dataSource];
      const target = newData.filter(item => record.key === item.key)[0];
      let locationList = []
      if (target) {
        target[column] = value;
        console.log(newData)
        this.dataSource = newData;
      }
    },
    handleChangeArea(value, record, column) {
      const newData = [...this.dataSource];
      const target = newData.filter(item => record.key === item.key)[0];
      let locationList = []
      whlsp.listWarehouseLocationByMaterial(value,"",record.materialId).then(res =>{
        locationList = res
        if (target) {
          const area = this.allAreaList.find(res => res.id === value)
          target['area'] = area.name
          target['locationList'] = locationList
          target['location'] = ""
          console.log(target,locationList)
          this.dataSource = newData;
        }
      })
    },
    changeLocationId(value, record) {
      const newData = [...this.dataSource];
      const target = newData.filter(item => record.key === item.key)[0];
      if (target) {
        const area = record.locationList.find(res => res.id === value)
        target['location'] = area.warehouseLocationName
        this.dataSource = newData;
      }
    },
    close(){
      this.form.resetFields()
      this.dataSource = []
      this.cacheData = [],
      this.$emit('close')
    },
    save(){
      let mesg = 0
      this.dataSource.forEach((element,index) => {
        const maxNum = element.stockOutNum - element.acceptedNum
        if(element.number === undefined || element.number === null){
          this.$message.warning(this.$t('page_plan_refund_confirmation_not'))
          mesg = mesg + 1
          return
        }
        // if(element.number > maxNum){
        //   this.$message.warning(`收领数量不能大于未领数量`)
        //   mesg = mesg + 1
        //   return
        // }
      });
      if(mesg > 0) return
      this.loading = true
      const list = []
      this.dataSource.forEach(item => {
        const area = this.allAreaList.find(res => res.name === item.area)
        const person = this.employeesList.find(res => res.id === item.collectionPerson)
        const data = {
          area: area ? area.name : "",
          collectionPerson: person ? person.name : "",
          location: item.location,
          materialCode: item.materialCode,
          materialName: item.materialName,
          number: item.number,
          planMaterialId: item.planMaterialId,
          standardModel: item.standardModel,
          unit: item.unit
        }
        list.push(data)
      });
      const values:any = {
        collectMaterialDTOList: list,
        planCode: this.plan.code,
        planId: this.plan.id,
        planNum: this.plan.planNum,
        version: this.plan.craftVersion
      }
      mcrsp.returnMaterial(values).then(() =>{
        this.form.resetFields()
        this.dataSource = []
        this.cacheData = [],
        this.$emit('reload')
        this.loading = false
        this.$message.success(this.$t('save_success'))
      }).catch(() =>{
        this.loading = false
      })
    }
  }
})

